export default __webpack_public_path__ + "static/media/11.2fbd5b44.png";